
import BaseField from '@/views/Company/Settings/Narrowcasting/Collections/BaseField.vue'
import { Component } from 'vue-property-decorator'
import { isArray, isEmpty } from 'lodash'

@Component
export default class BaseCommaSeperatedField extends BaseField {
    mounted(): void {
        this.applyInitialValues()
    }

    applyInitialValues() {
        if (!this.value || isEmpty(this.value.values)) {
            return
        }

        this.internalValue = (this.value.values as string[]).join()
        this.enabled = this.fieldValues !== null
    }

    get fieldValues(): object|string[] {
        if (isArray(this.internalValue)) {
            return this.internalValue
        }

        if (!this.internalValue || this.internalValue.length === 0) {
            return null
        }

        return this.internalValue
            .split(',')
            .filter(v => !!v)
            .map(v => v.trim())
    }
}
